module.exports = __webpack_public_path__ + "static/media/front.d3920613.jpg";